import { del, get, post, put } from '../../utils/api';
import axios from 'axios';

export const getTransactionsStats = async () => {
  const {
    data: { data },
  } = await get('pos/v1/transaction/stats');
  return data;
};

export const getAllOpenedTransactions = async () => {
  const {
    data: { data },
  } = await get('pos/v1/transaction/opened');
  return data;
};

export const getDataForClosure = async () => {
  const {
    data: { data },
  } = await get(`pos/v1/closure/data`);
  return data;
};

export const getClosedTransactionsWithoutClosure = async (page, pageSize) => {
  const {
    data: { data },
  } = await get(`pos/v1/transaction/closed?page=${page}&pageSize=${pageSize}`);
  return data;
};

export const getRsTransactions = async () => {
  const {
    data: { data },
  } = await get('pos/v1/rstemplate');
  return data;
};

export const createTransactionFromTemplate = async (templateId) => {
  const {
    data: { transactionID },
  } = await post('pos/v1/transaction', {
    templateId
  });

  return transactionID;
};

export const getTransactionDetail = async (id) => {
  const { data } = await get(`pos/v1/transaction/${id}`);
  return data;
};

export const getClosedTransactionDetail = async (id) => {
  const { data } = await get(`pos/v1/transactionDetail/${id}`);
  return data;
};

export const addItemToTransaction = async (transactionId, itemId, quantity) => {
  const { data } = await post(`pos/v1/transaction/${transactionId}/item`, {
    itemId: itemId,
    quantity: quantity,
  });
  return data;
};

export const addItemToTransactionByBarcode = async (transactionId, barcode, quantity) => {
  const { data } = await post(`pos/v1/transaction/${transactionId}/item`, {
    barcode: barcode,
    quantity: quantity,
  });
  return data;
};

export const updateTransactionItemQuantity = async (transactionId, lineId, quantity) => {
  const { data } = await put(`pos/v1/transaction/${transactionId}/item/${lineId}`, {
    quantity: quantity,
  });
  return data;
};

export const removeTransactionItem = async (transactionId, lineId) => {
  const { data } = await del(`pos/v1/transaction/${transactionId}/item/${lineId}`);
  return data;
};

export const postTransaction = async (transactionId, paymentType, paymentAmount) => {
  const { data } = await put(`pos/v1/transaction/${transactionId}/post`, {
    payment: {
      paymentAmount: paymentAmount,
      paymentType: paymentType,
    },
  });
  return data;
};

export const cancelTransaction = async (transactionId) => {
  const { data } = await put(`pos/v1/transaction/${transactionId}/cancel`);
  return data;
};

export const getPrintData = async (transactionId) => {
  const { data } = await get(`pos/v1/transaction/${transactionId}/print`);
  return data;
};

export const getPrinterData = async () => {
  const { data } = await get(`pos/v1/transaction/printer`);
  return data;
};

export const printReceipt = async (printerServer, token, printerIp, printerPort, data ) => {
  console.log(printerServer, token, printerIp, printerPort, data);
  await axios.post(
    printerServer + '/api/printv2',
    {
      token: token,
      printerIP: printerIp,
      printerPort: printerPort,
      data,
    },
  )
}

export const openCashTray = async (printerServer, token, printerIp, printerPort ) => {
  console.log(printerServer, token, printerIp, printerPort);
  await axios.post(
      printerServer + '/api/opendrawer',
      {
        token: token,
        printerIP: printerIp,
        printerPort: printerPort,
      },
  )
}
